import {fetchSpecsheet} from '../slices/specsheetSlice';

export const kirbySpecsheetMiddleware = store => next => action => {
	const result = next(action);

	if (action.type === 'status/setLang') {
		// pick section config base on ProductModel
		// console.log('setLang', store.getState().specsheet, store.getState().status.lang, action.payload.lang);
		store.dispatch(fetchSpecsheet());
	}

    return result;
};
